import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core"
import ExternalUrls from "../app/ExternalUrls";
import Images from "../assets/images";
import AppInitSingletonBo from "../consumer/init/AppInitSingletonBo";
import FlexNewLine from "./cmp/flex/FlexNewLine";
import ExternalLink from "./cmp/link/ExternalLink";
import useAppCtx from "../app/ctx-provider/useAppCtx";
import StvPage from "../app/ctx-provider/StvPage";

const useStyles = makeStyles((theme: Theme) => createStyles({
    imgGalleryItem: {
        maxHeight: 80,
        width: 'auto'
    },

    flexItem: {
        paddingLeft: 15,
        paddingRight: 15,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 5,
            paddingRight: 5,
        },

        margin: 5,

    }
}));

const FlexItem: React.FC = ({ children }) => {
    const classes = useStyles();
    return (
        <div className={classes.flexItem}>
            {children}
        </div>);
}

const LinkText: React.FC<{ txt: string }> = ({ txt }) =>
    <Typography variant='caption' color='textSecondary'>{txt}</Typography>;


const AppFooter: React.FC = () => {
    const classes = useStyles();
    const { appCtxBo } = useAppCtx();

    const renderKampagne = AppInitSingletonBo.existKampagne() && appCtxBo.currentPage === StvPage.HOMEPAGE;

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', padding: 5 }}>

            <FlexItem>
                <img className={classes.imgGalleryItem} src={Images.ascore} alt="RheinLand Versicherungsgruppe score" />
            </FlexItem>

            <FlexItem>
                <img className={classes.imgGalleryItem} src={Images.tuev} alt="RheinLand Versicherungsgruppe Testmark" />
            </FlexItem>

            <FlexNewLine />

            <FlexItem>
                <ExternalLink href={ExternalUrls.RHLD_IMPRESSUM}>
                    <LinkText txt='Impressum' />
                </ExternalLink>
            </FlexItem>

            <FlexItem>
                <ExternalLink href={ExternalUrls.RHLD_DATENSCHUTZ}>
                    <LinkText txt='Datenschutz' />
                </ExternalLink>
            </FlexItem>

            <FlexItem>
                <ExternalLink href={ExternalUrls.RHLD_NUTZUNGSBEDINGUNGEN}>
                    <LinkText txt='Nutzungsbedingungen' />
                </ExternalLink>
            </FlexItem>

            <FlexNewLine />

            {renderKampagne &&
                <FlexItem>
                    <div style={{ maxWidth: 1024, textAlign: 'center' }}>
                        <Typography variant='caption' color='textSecondary' >
                            * Aktion gilt vom 30.11.21 - 31.12.22. Nur solange der Vorrat reicht. Der Versicherungsnehmer erhält die Prämie postalisch, sobald ein Tierhalter-Haftpflicht Vertrag bei uns abgeschlossen wurde. Eine Barauszahlung ist nicht möglich. Die vertretenen Marken sind nicht Sponsoren oder auf sonstige Weise mit der RheinLand Versicherungs AG verbunden. Die Logos und sonstigen beigefügten Kennzeichen sind Marken, die Eigentum jeder vertretenen Firma oder ihrer verbundenen Unternehmen sind.
                        </Typography>
                    </div>
                </FlexItem>
            }

        </div >
    );
}

export default AppFooter;